import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "search",
    "searchWrapper",
    "dropdown",
    "item",
    "selected",
    "selectedTemplate",
    "hiddenInput",
  ];

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  showDropdown() {
    this.dropdownTarget.classList.remove("hidden");
    this.filter();
  }

  hideDropdown() {
    this.dropdownTarget.classList.add("hidden");
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown();
    }
  }

  filter() {
    const term = this.searchTarget.value.toLowerCase();
    this.itemTargets.forEach((el) => {
      const text = el.textContent.toLowerCase();
      el.classList.toggle("hidden", !text.includes(term));
    });
  }

  select(event) {
    const item = event.currentTarget;
    this.hiddenInputTarget.value = item.dataset.userId;

    const clone = this.selectedTemplateTarget.content.cloneNode(true);
    clone.querySelector("[data-name]").textContent = item.dataset.userName;
    clone.querySelector("[data-email]").textContent = item.dataset.userEmail;

    this.selectedTarget.replaceChildren(clone);
    this.selectedTarget.classList.remove("hidden");
    this.searchWrapperTarget.classList.add("hidden");
    this.hideDropdown();
  }

  clear(event) {
    event.preventDefault();
    event.stopPropagation();
    this.hiddenInputTarget.value = "";
    this.selectedTarget.classList.add("hidden");
    this.selectedTarget.replaceChildren();
    this.searchWrapperTarget.classList.remove("hidden");
    this.searchTarget.value = "";
  }
}
